import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import type { ICreativeAttributes } from './creatives_base';
import { Creative, CreativeClass } from './creatives_base';

// =============================================================================
// Referral Page Creative Types
// =============================================================================

export type TReferralPageCreative = ICreativeAttributes & {
  participant: string;
  redirect_url: string;
};

// =============================================================================
// Referral Page Creative Class
// =============================================================================

/**
 * ReferralPageCreative handles referral campaign landing page creatives.
 * These are participant-specific landing pages with redirect URLs.
 */
export class ReferralPageCreative extends Creative<TReferralPageCreative> {
  public readonly className = 'ReferralPageCreative';

  public override get constraints(): TConstraints<TReferralPageCreative> {
    return super.constraints;
  }

  constructor(attributes: Partial<TReferralPageCreative>) {
    super(attributes);

    makeObservable(this);
  }

  public override getDefaults(): Partial<TReferralPageCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.ReferralPage,
    };
  }
}
